import {
  BarChart3,
  Building,
  Database,
  FileText,
  FolderTree,
  Key,
  LayoutDashboard,
  Mail,
  Settings,
  Share2,
  Shield,
  UserCheck,
  Users,
  Webhook,
  Workflow,
  Activity,
  NotepadTextDashed,
  Bell,
  // Megaphone,
  // Megaphone,
  User,
} from "lucide-react";
import { BiGitCompare } from "react-icons/bi";

export interface MenuItem {
  title: string;
  icon: JSX.Element;
  path: string;
  /** Tailwind text-color class for the icon when the item is NOT active. */
  iconColor?: string;
  children?: MenuItem[];
  badge?: string;
  /** Hide the item when the user lacks this single permission. */
  permission?: string;
  /** Hide the item when the user has NONE of these (OR semantics). */
  anyOf?: string[];
}

export const menuItems: MenuItem[] = [
  {
    title: "Dashboard",
    icon: <LayoutDashboard className="w-5 h-5" />,
    iconColor: "text-indigo-500",
    path: "/dashboard",
    permission: "dashboard:view",
  },
  {
    title: "Documents",
    icon: <FileText className="w-5 h-5" />,
    iconColor: "text-blue-500",
    path: "/documents",
    permission: "documents:view",
  },
  {
    title: "Workflows",
    icon: <Workflow className="w-5 h-5" />,
    iconColor: "text-violet-500",
    path: "/workflow",
    permission: "workflows:view",
  },
  {
    title: "Document Search",
    icon: <Database className="w-5 h-5" />,
    iconColor: "text-cyan-500",
    path: "/document-search",
    permission: "documents:search",
  },
  {
    title: "Compare Docs",
    icon: <BiGitCompare className="w-5 h-5" />,
    iconColor: "text-teal-500",
    path: "/document-compare",
    permission: "documents:compare",
  },
  // {
  //   title: "Intelligence",
  //   icon: <Megaphone className="w-5 h-5" />,
  //   iconColor: "text-blue-500",
  //   path: "/campaigns",
  //   badge: "New",
  //   // No dedicated permission yet — gate behind the broader document/search permissions.
  //   anyOf: ["documents:view", "documents:search"],
  // },
  {
    title: "Field Mapping",
    icon: <FolderTree className="w-5 h-5" />,
    iconColor: "text-emerald-500",
    path: "/templates",
    anyOf: ["templates:view", "documents:parse"],
    children: [
      {
        title: "File parser",
        icon: <Webhook className="w-4 h-4" />,
        iconColor: "text-emerald-500",
        path: "/file-parser",
        permission: "documents:parse",
      },
      {
        title: "Templates",
        icon: <Share2 className="w-4 h-4" />,
        iconColor: "text-emerald-500",
        path: "/templates",
        permission: "templates:view",
      },
    ],
  },
  {
    title: "User Management",
    icon: <Users className="w-5 h-5" />,
    iconColor: "text-rose-500",
    path: "/users",
    anyOf: ["users:view", "groups:view", "roles:view"],
    children: [
      {
        title: "Users",
        icon: <UserCheck className="w-4 h-4" />,
        iconColor: "text-rose-500",
        path: "/users",
        permission: "users:view",
      },
      {
        title: "Groups",
        icon: <FolderTree className="w-4 h-4" />,
        iconColor: "text-rose-500",
        path: "/groups",
        permission: "groups:view",
      },
      {
        title: "Invitations",
        icon: <Mail className="w-4 h-4" />,
        iconColor: "text-rose-500",
        path: "/admin/users/invitations",
        permission: "users:invite",
      },
      {
        title: "Roles",
        icon: <Shield className="w-4 h-4" />,
        iconColor: "text-rose-500",
        path: "/roles",
        permission: "roles:view",
      },
    ],
  },
  {
    title: "Reports",
    icon: <BarChart3 className="w-5 h-5" />,
    iconColor: "text-orange-500",
    path: "/reports",
    anyOf: [
      "reports:audit_trail",
      "reports:document_processing",
      "reports:user_activity",
    ],
    children: [
      {
        title: "Audit Trail Report",
        icon: <Activity className="w-5 h-5" />,
        iconColor: "text-orange-500",
        path: "/audit-trail",
        permission: "reports:audit_trail",
      },
      {
        title: "User Activity Report",
        icon: <User className="w-5 h-5" />,
        iconColor: "text-orange-500",
        path: "/user-activity-report",
        permission: "reports:user_activity",
      },
      {
        title: "Document Processing Report",
        icon: <NotepadTextDashed className="w-5 h-5" />,
        iconColor: "text-orange-500",
        path: "/document-processing-report",
        permission: "reports:document_processing",
      },
    ],
  },
  {
    title: "Business Settings",
    icon: <Settings className="w-5 h-5" />,
    iconColor: "text-slate-500",
    path: "/business-settings",
    permission: "settings:view",
  },
  {
    // Single Notification entry — opens the management page. The three
    // tabs (My Notifications · Preferences · Push Subscribers) live
    // inside the page itself, no submenu needed.
    title: "Notifications",
    icon: <Bell className="w-5 h-5" />,
    iconColor: "text-sky-500",
    path: "/notifications/manage",
    permission: "notifications:view",
  },
  {
    title: "Enterprise",
    icon: <Building className="w-5 h-5" />,
    iconColor: "text-purple-500",
    path: "/enterprise",
    anyOf: ["enterprise:sso_config", "enterprise:tenants"],
    children: [
      {
        title: "SSO config",
        icon: <Key className="w-4 h-4" />,
        iconColor: "text-purple-500",
        path: "/enterprise/sso-config",
        permission: "enterprise:sso_config",
      },
      {
        title: "Tenants",
        icon: <Building className="w-4 h-4" />,
        iconColor: "text-purple-500",
        path: "/enterprise/tenants",
        permission: "enterprise:tenants",
      },
    ],
  },
];
